<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="mx-auto mt-5" outlined tile>
          <v-toolbar flat>
            <v-text-field
              label="Search by name, email, or phone number"
              v-model="search"
              prepend-icon="search"
              clearable
              hide-details
              single-line
            />
            <v-select
              label="Active"
              v-model="filterIsActive"
              :items="filterIsActiveItems"
              hide-details
              single-line
              class="ml-2"
            />
          </v-toolbar>
          <v-data-table
            dense
            must-sort
            :headers="this.headers"
            :options.sync="options"
            :footer-props="footerProps"
            :server-items-length="this.trainees.count"
            :items="this.trainees.items"
            :loading="$apollo.queries.trainees.loading"
            item-key="_id"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.name }}</td>
                <td>{{ item.familyName }}</td>
                <td>{{ item.givenName }}</td>
                <td><a :href="`mailto:${item.email}`">{{ item.email }}</a></td>
                <td><a :href="`tel:${item.phoneNumber}`">{{ item.phoneNumber }}</a></td>
                <td><v-icon>{{ item.isActive | checkMark }}</v-icon></td>
                <td class="text-end">
                  <v-btn small icon @click="editTrainee(item)">
                    <v-icon color="primary">edit</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>

            <template v-slot:footer.prepend>
              <v-btn
                icon
                :loading="$apollo.queries.trainees.loading"
                :disabled="$apollo.queries.trainees.loading"
                @click="$apollo.queries.trainees.refresh()"
              >
                <v-icon>refresh</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from 'graphql-tag'

import gqlSortMixin from '../mixins/gql-sort-mixin'

export default {
  name: 'AdminTraineesView',

  mixins: [
    gqlSortMixin
  ],

  data: () => ({
    search: null,
    headers: [
      {
        text: 'Name',
        value: 'name'
      },
      {
        text: 'Family Name',
        value: 'familyName'
      },
      {
        text: 'Given Name',
        value: 'givenName'
      },
      {
        text: 'Email',
        value: 'email'
      },
      {
        text: 'Phone Number',
        value: 'phoneNumber'
      },
      {
        text: 'Active',
        value: 'active',
        sortable: false
      },
      {
        text: 'Actions',
        value: 'actions',
        class: 'text-end',
        sortable: false
      }
    ],
    options: {
      multiSort: false,
      mustSort: true,
      sortDesc: [false],
      sortBy: ['familyName'],
      page: 1,
      itemsPerPage: 25
    },
    footerProps: {
      'items-per-page-options': [10, 25, 50, 100, 200, 500]
    },
    trainees: {
      count: 0,
      items: []
    },
    filterIsActive: null,
    filterIsActiveItems: [
      { value: null, text: 'Any' },
      { value: true, text: 'Active' },
      { value: false, text: 'Inactive' }
    ]
  }),

  computed: {
    filter () {
      const filter = {
        isTrainee: true,
        ...(this.filterIsActive !== null && { isActive: this.filterIsActive })
      }
      if (this.search) {
        const regex = `/${this.search}/gi`
        filter.OR = [{
          _operators: {
            name: { regex }
          }
        }, {
          _operators: {
            givenName: { regex }
          }
        }, {
          _operators: {
            familyName: { regex }
          }
        }, {
          _operators: {
            email: { regex }
          }
        }, {
          _operators: {
            phoneNumber: { regex }
          }
        }]
      }
      return filter
    }
  },

  apollo: {
    trainees: {
      query: gql`query ListTrainees($filter: FilterFindManyPersonInput, $page: Int!, $perPage: Int!, $sort: SortFindManyPersonInput!) {
        trainees: personManyPagination(filter: $filter, page: $page, perPage: $perPage, sort: $sort) {
          count
          items {
            _id
            isActive
            email
            name
            givenName
            familyName
            phoneNumber
          }
        }
      }`,
      variables () {
        return {
          filter: this.filter,
          page: this.options.page,
          perPage: this.options.itemsPerPage,
          sort: this.gqlSort(this.options)
        }
      },
      error (e) {
        this.onError(e)
      },
      debounce: 250
    }
  },

  methods: {
    onError (e) {
      this.$emit('error', e)
    },

    editTrainee (trainee) {
      this.$router.push({ name: 'AdminPerson', params: { id: trainee._id } })
    }
  }
}
</script>
